module.exports = __webpack_public_path__ + "static/dyson-611eea22293a3936c20d2faefa80c10f.jpg";